import {
  IMPORTING_BATCH_ADJUSTMENTS,
  IMPORTING_BATCH_ADJUSTMENTS_SUCCESS,
  IMPORTING_BATCH_ADJUSTMENTS_FAILURE,
  UPLOAD_BATCH_ADJUSTMENTS,
  UPLOAD_BATCH_ADJUSTMENTS_SUCCESS,
  UPLOAD_BATCH_ADJUSTMENTS_FAILURE,
  RESET_UPLOADED_BATCH_ADJUSTMENTS,
} from './types';
import initialState from './initialState';

function batchAdjustmentsReducer(state = initialState, action) {
  switch (action.type) {
    case UPLOAD_BATCH_ADJUSTMENTS:
      return {
        ...state,
        uploadingBatchAdjustments: true,
      };
    case UPLOAD_BATCH_ADJUSTMENTS_SUCCESS:
      return {
        ...state,
        uploadedBatchAdjustments: action.batchAdjustments,
        uploadingBatchAdjustments: false,
      };
    case UPLOAD_BATCH_ADJUSTMENTS_FAILURE:
      return {
        ...state,
        uploadingBatchAdjustments: false,
      };
    case IMPORTING_BATCH_ADJUSTMENTS:
      return {
        ...state,
        importingBatchAdjustments: true,
      };
    case IMPORTING_BATCH_ADJUSTMENTS_SUCCESS:
      return {
        ...state,
        uploadedBatchAdjustments: initialState.uploadedBatchAdjustments,
        importingBatchAdjustments: false,
      };
    case IMPORTING_BATCH_ADJUSTMENTS_FAILURE:
      return {
        ...state,
        importingBatchAdjustments: false,
      };
    case RESET_UPLOADED_BATCH_ADJUSTMENTS:
      return {
        ...state,
        uploadedBatchAdjustments: initialState.uploadedBatchAdjustments,
      };
    default:
      return state;
  }
}

export default batchAdjustmentsReducer;
